<template>
  <div class="module-edit-page">
    <v-container fluid class="px-6 py-4">
      <!-- Page Header -->
      <div class="page-header mb-6">
        <div class="header-content">
          <div class="page-title-section">
            <div class="d-flex align-center mb-2">
              <v-btn
                icon
                color="primary"
                @click="$router.back()"
                class="back-btn mr-3"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <h1 class="page-title">
                <v-icon large class="vibrant-title-icon mr-3">mdi-view-module-outline</v-icon>
                Edit Module
                <span class="page-inline-subtitle">Update module details and settings</span>
              </h1>
              <v-spacer></v-spacer>
              <div class="header-actions">
                <!-- Header actions removed - button moved to bottom -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Module Form Card -->
      <v-card class="module-form-card" elevation="8">
        <v-card-title class="modern-card-title">
          <h2 class="card-title">
            <v-icon class="mr-2">mdi-form-select</v-icon>
            Module Information
          </h2>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Module Name *"
                prepend-inner-icon="mdi-view-module"
                :error-messages="errors.name"
                class="minimal-input"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-switch
                v-model="form.is_active"
                inset
                color="primary"
                :label="`Status: ${form.is_active ? 'Active' : 'Inactive'}`"
                class="minimal-switch mt-2"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        
        <!-- Form Actions -->
        <v-card-actions class="minimal-actions pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            text
            @click="$router.back()"
            class="minimal-cancel-btn mr-2"
          >
            <v-icon left small>mdi-arrow-left</v-icon>
            Cancel
          </v-btn>
          <v-btn 
            color="primary" 
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
            class="minimal-save-btn"
            elevation="1"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Update Module
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "@/axios";

export default {
  name: "ModuleEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      errors: {},
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.moduleId;
      axios
        .get(`modules/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(`modules/${this.$route.params.moduleId}`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/module/${this.form.id}`,
          from_name: "ModuleEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`user_timestamps`, form);
        this.$router.push("/modules");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.module-edit-page {
  min-height: calc(100vh - 64px);
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 20px;
  padding: 16px 20px;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.1);
  position: relative;
  overflow: hidden;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #667eea !important;
}

.vibrant-title-icon {
  background: linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 25%, #667eea 50%, #764ba2 75%, #f093fb 100%) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  font-weight: 900 !important;
  filter: drop-shadow(0 2px 6px rgba(102, 126, 234, 0.4)) drop-shadow(0 0 12px rgba(255, 107, 107, 0.3));
  animation: pulse-glow 3s ease-in-out infinite;
  font-size: 32px !important;
}

@keyframes pulse-glow {
  0%, 100% { 
    filter: drop-shadow(0 2px 6px rgba(102, 126, 234, 0.4)) drop-shadow(0 0 12px rgba(255, 107, 107, 0.3));
    transform: scale(1);
  }
  50% { 
    filter: drop-shadow(0 4px 12px rgba(102, 126, 234, 0.6)) drop-shadow(0 0 20px rgba(255, 107, 107, 0.5));
    transform: scale(1.05);
  }
}

.page-inline-subtitle {
  font-size: 16px;
  color: #64748b;
  font-weight: 400;
  margin-left: 16px;
  display: inline;
}

.page-title-section {
  flex: 1;
  width: 100%;
}

.header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
  justify-self: flex-end;
  margin-left: auto;
}

.back-btn {
  background: rgba(102, 126, 234, 0.1) !important;
  border: 1px solid rgba(102, 126, 234, 0.2) !important;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(102, 126, 234, 0.15) !important;
  transform: translateX(-2px);
}

/* Minimal Form Card */
.module-form-card {
  border-radius: 12px !important;
  border: 1px solid rgba(102, 126, 234, 0.15);
  background: white;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.08) !important;
  margin-top: 16px;
}

.modern-card-title {
  background: white;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
  padding: 16px 20px !important;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

/* Minimal Form Elements */
.minimal-input >>> .v-input__control .v-input__slot {
  border-radius: 8px !important;
  transition: border-color 0.2s ease;
  border-color: rgba(102, 126, 234, 0.2) !important;
  background: white !important;
  min-height: 40px !important;
}

.minimal-input >>> .v-input__control .v-input__slot:hover {
  border-color: #667eea !important;
}

.minimal-input >>> .v-input--is-focused .v-input__control .v-input__slot {
  border-color: #667eea !important;
  box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.2) !important;
}

.minimal-input >>> .v-text-field__prefix,
.minimal-input >>> .v-text-field__suffix {
  color: #667eea !important;
}

.minimal-input >>> .v-label {
  color: #64748b !important;
  font-weight: 400;
  font-size: 14px;
}

.minimal-input >>> .v-label--active {
  color: #667eea !important;
  font-weight: 500;
}

.minimal-input >>> input {
  color: #2c3e50 !important;
  font-weight: 400;
  font-size: 14px;
}

.minimal-input >>> .v-text-field__details {
  padding-top: 4px;
}

.minimal-input >>> .v-messages {
  color: #64748b;
  font-size: 11px;
}

/* Minimal Switch styling */
.minimal-switch >>> .v-label {
  color: #2c3e50 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

.minimal-switch >>> .v-input--switch__thumb {
  background: #667eea !important;
}

.minimal-switch >>> .v-input--switch__track {
  border-radius: 12px !important;
}

/* Minimal Form Actions */
.minimal-actions {
  background: #fafafa;
  border-top: 1px solid rgba(102, 126, 234, 0.1);
  justify-content: flex-end !important;
  gap: 8px;
}

.minimal-cancel-btn {
  color: #64748b !important;
  border-radius: 6px !important;
  text-transform: none !important;
  font-weight: 400 !important;
  padding: 0 16px !important;
  height: 36px !important;
  font-size: 13px !important;
}

.minimal-cancel-btn:hover {
  background: rgba(100, 116, 139, 0.1) !important;
}

.minimal-save-btn {
  background: #667eea !important;
  color: white !important;
  border-radius: 6px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 0 20px !important;
  height: 36px !important;
  font-size: 13px !important;
  min-width: 100px !important;
}

.minimal-save-btn:hover {
  background: #5a6fd8 !important;
}

.minimal-save-btn:before {
  background-color: transparent;
}

/* Minimal Container Spacing */
.pa-4 {
  padding: 20px !important;
}

/* Responsive Minimal Layout */
@media (max-width: 960px) {
  .pa-4 {
    padding: 16px !important;
  }
  
  .page-header {
    padding: 16px;
    margin-bottom: 16px;
  }
  
  .page-title {
    font-size: 20px;
  }
  
  .modern-card-title {
    padding: 14px 16px !important;
  }
  
  .module-form-card {
    margin-top: 12px;
  }
}

@media (max-width: 600px) {
  .pa-4 {
    padding: 12px !important;
  }
  
  .minimal-actions {
    flex-direction: row;
    justify-content: center;
  }
  
  .minimal-cancel-btn,
  .minimal-save-btn {
    min-width: 80px !important;
  }
  
  .page-header {
    padding: 12px;
    margin-bottom: 12px;
  }
  
  .page-title {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
    text-align: center;
  }
  
  .page-inline-subtitle {
    display: block;
    margin-left: 0;
    margin-top: 4px;
    text-align: center;
    font-size: 13px;
  }
  
  .modern-card-title {
    padding: 12px 16px !important;
  }
  
  .card-title {
    font-size: 16px;
    justify-content: center;
  }
  
  .module-form-card {
    margin-top: 8px;
    border-radius: 8px !important;
  }
}

/* Minimal Animation */
.module-form-card {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Minimal Loading State */
.minimal-save-btn.v-btn--loading {
  pointer-events: none;
}

.minimal-save-btn.v-btn--loading >>> .v-btn__content {
  opacity: 0.7;
}
</style>